import GenericRestrictionValue from "../restrictions/values/generic_restriction_value";

export const PLATFORM_TYPES = {
	ALL: 'All',
	MOBILE: 'Mobile',
	PC: 'PC',
	NONE: 'None',
};

export type RegulationApprovalValues = [boolean, boolean] | boolean;
export type RegulationApprovalsType = boolean | Record<number, RegulationApprovalValues> | undefined;

export enum VOLATILITY_LIMITS {
    Low = 40.45142,
    Medium = 44.16644
}

export enum GAME_VOLATILITY {
	None = -1,
    Low = 0,
    Medium = 1,
    High = 2
};

export interface ILocalizedGameInfo {
	gameType: number;
	externalGameCode: string;
	externalGameSubType: string;
	title: string;
	hasJackpot: boolean;
	vendorId: number;
	vendorName: string;
	companyId?: number;
	companyName: string;
	gameGroup: string;
	subGroupName: string;
	gameGroupId: number;
	isAnonymousSupported: boolean;
	forceDemoButton: boolean;
	numberOfLines?: number;
	hasFreeSpins: boolean;
	allowedPlatformType: string;
	hasSideBets: boolean;
	isMultiHand: boolean;
	maxBetPerSpot?: number;
	numberOfDecks?: number;
	hasBonusGames: boolean;
	minBet: any;
	maxBet: any;
	approvals: RegulationApprovalsType;
	restriction?: GenericRestrictionValue;
	isCurrentPlatformAllowed?: boolean;
	isEliteLounge: boolean;
	allowWithdrawOnlyFromReal: boolean;
	maxBetPerBrand?: number;
	readonly showSwitchGameMode?: boolean;
	readonly gameThemes: number[];
	readonly volatility: GAME_VOLATILITY;
    readonly isChildish?: boolean;
    readonly hasNonChildishIcon?: boolean;
    readonly hasLessNonChildishIcon?: boolean;
}

export type GAMES_INFO = { [key: number]: ILocalizedGameInfo };

export default interface IGamesInformationService {
	getGamesInfoWithoutAnyFiltering(gameTypes: number[]): Promise<GAMES_INFO>;
	getGamesInfo(gameTypes: number[], overrideUnfilteredGames?: boolean): Promise<GAMES_INFO>;
	isGameAllowedAndExistsInHybrid(gameInfo: ILocalizedGameInfo): boolean;
	getAllGameTypes(): Promise<number[]>;
	getGamesSubTypesMappings(gameSubTypes?: string[]): { [key: string]: number };
	getAllGamesInfo(): Promise<GAMES_INFO>;
	getDiagnosticMessages(): string;
	isVideoSlotOrVideoPokerOrScratchCardsGameGroup(gameGroupId: number): boolean;
	isVideoSlotOrSlotsGameGroup(gameGroupId: number): boolean;
	isRouletteOrBlackjackOrBaccarat(gameGroupId: number): boolean;
    isLiveGamesGroup(gameGroupId: number): boolean;
	readonly themes: {[key: number]: string};
	readonly vendors: {[key: number]: string};
	readonly companies: {[key: number]: string};
}
